import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY


export class IntegracionProyectos {
    // areas
    static getAreas = async () => {
        try {
            const response = await api.get(`${urlApi}/dashboard/getAreas`);
            return response.data;
        } catch (error) {
            console.error("Error al obtener la integración de proyectos:", error);
            throw error;
        }
    }
    static updateArea = async (area) => {
        try {
            const response = await api.put(`${urlApi}/dashboard/updateArea`, area);
            return response.data;
        } catch (error) {
            console.error("Error al actualizar el área:", error);
            throw error;
        }
    }
    static createArea = async (area) => {
        try {
            const response = await api.post(`${urlApi}/dashboard/createArea`, area);
            return response.data;
        } catch (error) {
            console.error("Error al crear el área:", error);
            throw error;
        }
    }
    // proyectos
    static getProyectos = async () => {
        try {
            const response = await api.get(`${urlApi}/dashboard/getProyectos`);
            return response.data;
        }
        catch (error) {
            console.error("Error al obtener la integración de proyectos:", error);
            throw error;
        }
    }
    static updateProyecto = async (proyecto) => {
        try {
            const response = await api.put(`${urlApi}/dashboard/updateProyectos`, proyecto);
            return response.data;
        } catch (error) {
            console.error("Error al actualizar el proyecto:", error);
            throw error;
        }
    }
    static createProyecto = async (proyecto) => {
        try {
            const response = await api.post(`${urlApi}/dashboard/crearProyectos`, proyecto);
            return response.data;
        } catch (error) {
            console.error("Error al crear el proyecto:", error);
            throw error;
        }
    }
    // sprints
    static getSprint = async () => {
        try {
            const response = await api.get(`${urlApi}/dashboard/getSprints`);
            return response.data;
        }
        catch (error) {
            console.error("Error al obtener la integración de proyectos:", error);
            throw error;
        }
    }
    static updateSprint = async (sprint) => {
        try {
            const response = await api.put(`${urlApi}/dashboard/updateSprints`, sprint);
            return response.data;
        }
        catch (error) {
            console.error("Error al actualizar el sprint:", error);
            throw error;
        }
    }
    static createSprint = async (sprint) => {
        try {
            const response = await api.post(`${urlApi}/dashboard/createSprints`, sprint);
            return response.data;
        }
        catch (error) {
            console.error("Error al crear el sprint:", error);
            throw error;
        }
    }
    // tareas
    static getTareas = async () => {
        try {
            const response = await api.get(`${urlApi}/dashboard/getTareas`);
            return response.data;
        }
        catch (error) {
            console.error("Error al obtener la integración de proyectos:", error);
            throw error;
        }
    }
    static updateTarea = async (tarea) => {
        try {
            const response = await api.put(`${urlApi}/dashboard/updateTarea`, tarea);
            return response.data;
        }
        catch (error) {
            console.error("Error al actualizar la tarea:", error);
            throw error;
        }
    }
    static createTarea = async (tarea) => {
        try {
            const response = await api.post(`${urlApi}/dashboard/createTareas`, tarea);
            return response.data;
        }
        catch (error) {
            console.error("Error al crear la tarea:", error);
            throw error;
        }
    }
    static createTareaBloqueante = async (data) => {
        try {
            const response = await api.post(`${urlApi}/dashboard/createTareasBloqueantes`, data);
            return response.data;
        }
        catch (error) {
            console.error("Error al crear la tarea:", error);
            throw error;
        }
    }
    static deleteTareaBloqueante = async (data) => {
        try {
            const response = await api.delete(`${urlApi}/dashboard/eliminarVinculoTarea`, { data });
            return response.data;
        }
        catch (error) {
            console.error("Error al eliminar la tarea bloqueante:", error);
            throw error;
        }
    }
    // inputs
    static getUsuario = async () => {
        try {
            const response = await api.get(`${urlApi}/dashboard/getUsuario`);
            return response.data;
        } catch (error) {
            console.error("Error al obtener la integración de proyectos:", error);
            throw error;
        }
    }
    static getPrioridades = async () => {
        try {
            const response = await api.get(`${urlApi}/dashboard/getPrioridades`);
            return response.data;
        } catch (error) {
            console.error("Error al obtener la integración de proyectos:", error);
            throw error;
        }
    }
    static getStatus = async () => {
        try {
            const response = await api.get(`${urlApi}/dashboard/getStatus`);
            return response.data;
        } catch (error) {
            console.error("Error al obtener la integración de proyectos:", error);
            throw error;
        }
    }
}